export default {
  header: {
    p1: '首页',
    p2: '新加坡节点',
    p3: '我的记录',
    p4: '推荐计划',
    p5: '常见问题',
    p6: '中文',
    p7: '分享',
    p8: '连接钱包',
  },
  home: {
    p1: '21个根节点',
    p2: '绑定21座城市，每个城市2000份共建者数字身份凭证',
    p3: '开启您的Web3学习之旅，共建Web3人才基建新生态，赋能产业Web3升级',
    p4: '新加坡',
    p5: '每份价格根据城市开放时间递增30%',
    p6: '立即购买',
    p7: '推荐赚佣金',
    p8: '基于 BSC 链 · 安全透明',
    p9: '探索更多',
  },
  node: {
    p1: '新加坡',
    p2: '根节点',
    p3: '限量 2,000 份，收藏新加坡城市数字身份凭证并成为核心共建者，成为商学苑国际根节点的一份子',
    p4: '开放中',
    p5: '新加坡',
    p6: '每份',
    p7: '已铸造',
    p8: '剩余',
    p9: '份',
    p10: '支付方式',
    p11: '铸造数量',
    p12: '每个城市最多 50 份',
    p13: '总金额',
    p14: '立即铸造',
    p15: '连接钱包',
    p16: '城市总数',
    p17: '总量',
    p18: '每城市限量',
    p19: '每人每城市限购',
    p20: '确认铸造',
    p21: '请确认以下铸造信息',
    p22: '城市节点',
    p23: '新加坡',
    p24: '数量',
    p25: '份',
    p26: '支付方式',
    p27: '全额',
    p28: '总金额',
    p29: '黄金分配',
    p30: '取消',
    p31: '确认铸造',
    p32: '授权中',
    p34: '铸造中',
    p35: '点击确认铸造即表示您同意我们的服务条款',
  },
  record: {
    p1: '我的记录',
    p2: '我的',
    p3: '记录',
    p4: '查看您的铸造记录和推荐奖励明细',
    p5: '铸造记录',
    p6: '奖励明细',
    p7: '铸造记录',
    p8: '序号',
    p9: '时间',
    p10: '邀请地址',
    p11: '数量',
    p12: '暂无铸造记录',
    p13: '奖励总金额',
    p14: '推荐奖励',
    p15: '地址数',
    p16: '个地址',
    p17: '奖励金额',
    p18: '奖励记录',
    p19: '暂无奖励记录',
    p20: '时间',
    p21: '被邀請地址',
    p22: '推荐奖励',
    p23: '加载中',
    p24: '没有更多了',
    p25: '邀请好友',
    p26: '请先连接钱包',
    p27: '连接钱包后即可查看您的铸造记录和奖励明细',
    p28: '连接钱包',
  },
  share: {
    p1: '推荐计划',
    p2: '邀请好友，',
    p3: '共享收益',
    p4: '分享您的专属推荐链接，每成功推荐一位用户购买，您将获得丰厚的佣金奖励',
    p5: '直接推荐',
    p6: '您直接推荐用户购买时',
    p7: '佣金比例',
    p8: '每份可获得',
    p9: '间接推荐',
    p10: '您的下级推荐的用户购买时',
    p11: '佣金比例',
    p12: '每份可获得',
    p13: '佣金分配示例',
    p14: '场景',
    p15: '直推佣金',
    p16: '间推佣金',
    p17: '仅有直推',
    p18: 'A 推荐 B 购买',
    p19: '直推 + 间推',
    p20: 'A 推荐 B，B 推荐 C 购买',
    p21: '获取您的专属推荐链接',
    p22: '分享此链接给好友，他们通过链接购买后您将获得佣金',
    p23: '连接钱包',
    p24: '即时到账',
    p25: '佣金自动分配到您的钱包',
    p26: '无限推荐',
    p27: '推荐人数不设上限',
    p28: '永久绑定',
    p29: '推荐关系链上永久记录',
  },
  fq: {
    p1: '常见问题',
    p2: '常见问题',
    p3: '解答',
    p4: '如果您有其他问题，欢迎通过官方渠道联系我们',
  },
  foot: {
    p1: '基于 BSC 区块链的 Web3 咨询&教育&社区平台 NFT，收藏城市共建者数字身份凭证，共建 Web3 人才基建新生态。',
    p1_1: '资源链接',
    p2: '智能合约',
    p3: '社区',
    p4: '法律信息',
    p5: '服务条款',
    p6: '隐私政策',
    p7: '免责声明',
  }
}